import React from 'react';
import { FormTitleType } from '@upstart/harmony/lib/legos/ricForm/ricFormTypes';

function SchemaFormTitle({ formElement }: { formElement: FormTitleType }) {
  const { title } = formElement;

  return <div className="form-title">{title}</div>;
}

export default SchemaFormTitle;
